/* FTR · Footer — tape-measure ruler + mobile accordions
   Custom element, so it re-initialises automatically when the theme editor
   reloads the section (shopify:section:load). */
(function () {
  if (customElements.get('ftr-footer')) return;

  class FtrFooter extends HTMLElement {
    connectedCallback() {
      this.progress = 1;
      this.rafId = null;
      this.handleClick = this.handleClick.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.addEventListener('click', this.handleClick);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);

      this.canvas = this.querySelector('[data-ftr-ruler]');
      if (!this.canvas || !this.canvas.getContext) return;
      this.ctx = this.canvas.getContext('2d');

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const shouldAnimate = this.dataset.animate === 'true' && !reduceMotion && 'IntersectionObserver' in window;

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.draw());
        this.ro.observe(this.canvas);
      } else {
        this.handleResize = () => this.draw();
        window.addEventListener('resize', this.handleResize);
      }

      if (shouldAnimate) {
        this.progress = 0;
        this.io = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.io.disconnect();
            this.io = null;
            this.play();
          }
        }, { threshold: 0.2 });
        this.io.observe(this.canvas);
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.draw());
      }
      this.draw();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      if (this.ro) this.ro.disconnect();
      if (this.io) this.io.disconnect();
      if (this.handleResize) window.removeEventListener('resize', this.handleResize);
      if (this.rafId) cancelAnimationFrame(this.rafId);
    }

    play() {
      const duration = 1400;
      const start = performance.now();
      const tick = (now) => {
        const t = Math.min((now - start) / duration, 1);
        this.progress = 1 - Math.pow(1 - t, 3);
        this.draw();
        this.rafId = t < 1 ? requestAnimationFrame(tick) : null;
      };
      this.rafId = requestAnimationFrame(tick);
    }

    draw() {
      const canvas = this.canvas;
      const ctx = this.ctx;
      if (!canvas || !ctx) return;

      const w = canvas.clientWidth;
      const h = canvas.clientHeight;
      if (!w || !h) return;

      const dpr = window.devicePixelRatio || 1;
      const pw = Math.round(w * dpr);
      const ph = Math.round(h * dpr);
      if (canvas.width !== pw || canvas.height !== ph) {
        canvas.width = pw;
        canvas.height = ph;
      }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      const d = this.dataset;
      const step = Math.max(parseInt(d.tickStep, 10) || 8, 4);
      const limit = w * this.progress;
      const fontFamily = getComputedStyle(this).getPropertyValue('--ftr-body-font').trim() || 'sans-serif';

      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = d.bg || '#F6F3ED';
      ctx.fillRect(0, 0, w, h);

      // Ticks
      ctx.strokeStyle = d.tick || '#1B1B18';
      ctx.lineWidth = 1;
      ctx.beginPath();
      for (let x = 0, i = 0; x <= limit; x += step, i++) {
        let len = h * 0.22;
        if (i % 5 === 0) len = h * 0.38;
        if (i % 10 === 0) len = h * 0.6;
        const px = Math.round(x) + 0.5;
        ctx.moveTo(px, 0);
        ctx.lineTo(px, len);
      }
      ctx.stroke();

      // Numbers
      if (d.numbers === 'true') {
        ctx.fillStyle = d.tick || '#1B1B18';
        ctx.font = '10px ' + fontFamily;
        ctx.textBaseline = 'bottom';
        for (let x = 0, i = 0; x <= limit; x += step, i++) {
          if (i > 0 && i % 10 === 0) ctx.fillText(String(i / 10), x + 3, h - 6);
        }
      }

      // Location markers
      ctx.font = '600 10px ' + fontFamily;
      ctx.textBaseline = 'middle';
      this.querySelectorAll('[data-ftr-mark]').forEach((mark) => {
        const pos = Math.min(Math.max(parseFloat(mark.dataset.pos) || 0, 0), 100) / 100;
        const x = Math.round((w * pos) / step) * step;
        if (x > limit) return;
        ctx.fillStyle = d.mark || '#B23B2E';
        ctx.fillRect(x - 1, 0, 2, h);
        const label = mark.dataset.label || '';
        if (label) {
          const tw = ctx.measureText(label).width;
          const tx = x + 6 + tw > w ? x - 6 - tw : x + 6;
          ctx.fillText(label, tx, h * 0.62);
        }
      });
    }

    handleClick(event) {
      const btn = event.target.closest('[data-ftr-acc-btn]');
      if (!btn || !this.contains(btn)) return;
      const item = btn.closest('.ftr__acc');
      if (!item) return;
      const open = !item.classList.contains('is-open');
      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
    }

    handleBlockSelect(event) {
      if (!this.contains(event.target)) return;
      const item = event.target.classList.contains('ftr__acc') ? event.target : event.target.querySelector('.ftr__acc');
      if (!item) return;
      item.classList.add('is-open');
      const btn = item.querySelector('[data-ftr-acc-btn]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }
  }

  customElements.define('ftr-footer', FtrFooter);
})();
